import * as types from './types';
import Box from '../../../../helpers/request/box';

const BoxRequest = new Box();

export const optionEmailsRequestData = ({ commit, rootState }) => {
  const boxId = rootState.route.params.boxId;
  const optionId = rootState.route.params.optionId;
  const requestResouce = `${boxId}/option/${optionId}`;

  BoxRequest.resumeEmails(requestResouce)
    .then(response => commit(types.RESUME_EMAILS_SET_DATA, response.data));
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/optionEmails/actions.js
 **/